"use client";
import React, { useMemo } from "react";
import { PhotoSwipe, PhotoSwipeProps } from "react-photoswipe";
import { getCookieItem, jointImgUploadByUser } from "@/lib/commonService";
import { LANGUAGE_NAME, defaultImg } from "@/config/constConf";
import "./photoswiper.css";
import ReactDOM from "react-dom";
import { getGlobal } from "@/ui-component/utils";

//博主秀评论展示
//博主秀评论展示
export function PhotoSwiperTitle(data: any, notShowShoppingThis: boolean) {
    //使用地方太多不好统一传入t函数，采用cookie检测语言，写死字符串
    let title = "SHOP THIS LOOK";
    let rating = "Rating";
    //使用try catch 避免服务端报错
    try {
        const isEnglish = getCookieItem(LANGUAGE_NAME) === "en";
        if (!isEnglish) {
            title = "COMPRAR ESTE LOOK";
            rating = "Valoración";
        }
    } catch (e) {}
    return `<div class="PhotoSwiper">
                ${
                    !notShowShoppingThis
                        ? `<a class="bt C_bt tran" style="color:#333" href="/eyeglasses-p-${data.products_id}.html?utm_source=productpage&utm_medium=middlepart&utm_campaign=reviewonotherstyle" target="_blank">${title}</a>`
                        : ""
                }
                ${
                    data.reviews_rating
                        ? `<div>
                    <span>${rating}: </span>
                    <span class="ratingStar ${
                        data.reviews_rating >= 1 ? "" : "void"
                    }"></span>
                    <span class="ratingStar ${
                        data.reviews_rating >= 2 ? "" : "void"
                    }"></span>
                    <span class="ratingStar ${
                        data.reviews_rating >= 3 ? "" : "void"
                    }"></span>
                    <span class="ratingStar ${
                        data.reviews_rating >= 4 ? "" : "void"
                    }"></span>
                    <span class="ratingStar ${
                        data.reviews_rating >= 5 ? "" : "void"
                    }"></span>
                </div>`
                        : ""
                }
                <div style="white-space: initial;max-height: 300px;overflow-y:scroll;">${
                    data.reviews_text
                }</div>
                <div style="text-align:right"><b>${data.customers_name}</b></div>
            </div>`;
}

export function PhotoSwiperData(
    data: Record<string, any>,
    notShowShoppingThis: boolean,
): PhotoSwipe.Item & {
    title: string;
} {
    const img = new Image();
    img.crossOrigin = "anonymous";
    let url = jointImgUploadByUser(data.reviews_photo);
    img.src = url;
    return (img.onload = () => {
        return {
            src: url,
            w: img.width,
            h: img.height,
            title: PhotoSwiperTitle(data, notShowShoppingThis),
        };
    })();
}
/**
 *
 *
 * @export
 * @param {*} {items：展示对象, isOpen：是否显示, onClose：关闭, options, isPc：是否是PC端, maxImgSize：图片最大显示尺寸}
 * @returns
 */

interface IProps extends PhotoSwipeProps {
    isOpen: boolean;
    items: PhotoSwipe.Item[];
    options: any;
    onClose?(): void;
    maxImgSize?: IMaxImgSize;
}
interface IMaxImgSize {
    w: number;
    h: number;
}

const PhotoSwiper: React.FC<IProps> = (props) => {
    const { isOpen, items, options, onClose, maxImgSize } = props;
    const tempOptions = useMemo(() => {
        return { history: false, ...options };
    }, [options]);

    //图片保存本地功能涉及到图片跨域问题，前端无法解决。现隐藏该功能
    tempOptions.shareButtons = [
        {
            id: "facebook",
            label: "Share on Facebook",
            url: "https://www.facebook.com/sharer/sharer.php?u={{url}}",
        },
        {
            id: "twitter",
            label: "Tweet",
            url: "https://twitter.com/intent/tweet?text={{text}}&url={{url}}",
        },
        {
            id: "pinterest",
            label: "Pin it",
            url: "http://www.pinterest.com/pin/create/button/?url={{url}}&media={{image_url}}&description={{text}}",
        },
    ];

    const photoMemo = useMemo(() => {
        return (
            <PhotoSwipe
                isOpen={isOpen}
                items={items}
                options={tempOptions}
                onClose={() => onClose?.()}
                imageLoadComplete={(instance: PhotoSwipe, index, item) => {
                    const img = new Image();
                    img.crossOrigin = "anonymous";
                    img.src = item.src ?? defaultImg;
                    const srcWidth = document.body.clientWidth;
                    img.onload = () => {
                        const baseWidth = img.width / img.height;
                        item.w = props.maxImgSize
                            ? props.maxImgSize.w
                            : srcWidth;
                        item.h = props.maxImgSize
                            ? props.maxImgSize.h
                            : srcWidth / baseWidth;
                        (instance as any).updateSize(true); // 这里这个实例是有updateSize方法的
                    };
                }}
            />
        );
    }, [isOpen, items, onClose, props.maxImgSize, tempOptions]);

    return ReactDOM.createPortal(photoMemo, getGlobal().document.body);
};
export default PhotoSwiper;
